export default __webpack_public_path__ + "static/media/chevron-bar-contract.6ce60a82.svg";